import { ISVGIconProps } from '@northladder/design-system';

/**
 * -----------------------------------------------------------------------------
 * Renders a Music SVG icon with customizable height, width, and className.
 * The icon uses `currentColor` for its stroke, allowing color inheritance from parent elements.
 */
export function MusicSVGIcon({
  className,
  height = 24,
  width = 24,
}: ISVGIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="Group_2">
          <path
            d="M19 12.417V5C19 3.895 18.105 3 17 3H4C2.895 3 2 3.895 2 5V17C2 18.105 2.895 19 4 19H12.418"
            id="Path"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M8.41422 11.5858C9.19527 12.3668 9.19527 13.6332 8.41422 14.4142C7.63317 15.1953 6.36684 15.1953 5.58579 14.4142C4.80474 13.6332 4.80474 12.3668 5.58579 11.5858C6.36684 10.8047 7.63317 10.8047 8.41422 11.5858"
            id="Path_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M12 7L9 6V13"
            id="Path_3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M18.41 15.59L15.59 18.41"
            id="Path_4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M18.41 18.41L15.59 15.59"
            id="Path_5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M17 22C14.239 22 12 19.761 12 17C12 14.239 14.239 12 17 12C19.762 12 22 14.239 22 17C22 19.761 19.762 22 17 22"
            id="Path_6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}
